import { render, staticRenderFns } from "./drawing.vue?vue&type=template&id=5354a7ac&scoped=true&"
import script from "./drawing.vue?vue&type=script&lang=js&"
export * from "./drawing.vue?vue&type=script&lang=js&"
import style0 from "./drawing.vue?vue&type=style&index=0&id=5354a7ac&lang=scss&scoped=true&"
import style1 from "./drawing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354a7ac",
  null
  
)

export default component.exports